import Icon from "@/components/Icon"
import type { Nullable, SearchPattern } from "@/models"
import { faWaveSquare } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { computed, ref } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import EditableField from "../EditableField"
import EditSearchPattern from "./EditSearchPattern"

interface Props {
	searchPattern: Nullable<SearchPattern>
	setSearchPattern(searchPattern: SearchPattern): Promise<void>
}

const existingInstructionsStyles = css`
	position: relative;
	cursor: pointer;

	svg {
		color: #3ca500;
		font-size: 1.75rem;
	}

	span:first-child {
		position: absolute;
		width: 1.25rem;
		height: 1.25rem;
		font-size: 1.125rem;
		border-radius: 100%;
		color: white;
		background-color: var(--color-error);
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid black;
		font-weight: bold;

		top: -0.75rem;
		right: -0.75rem;
	}
`

const SearchPatternCell: ReactiveComponent<Props> = (props) => {
	const editing = ref(false)
	const hasSearchPatternDetails = computed(() => {
		return props.searchPattern !== null && 
				 ((props.searchPattern.commenceSearchPosition !== null && props.searchPattern.commenceSearchPosition.trim().length > 0) ||
				 (props.searchPattern.firstLegDirection !== null && props.searchPattern.firstLegDirection.trim().length > 0) ||
				 (props.searchPattern.firstTurn !== null && props.searchPattern.firstTurn.trim().length > 0) ||
				 (props.searchPattern.creepDirection !== null && props.searchPattern.creepDirection.trim().length > 0) ||
				 (props.searchPattern.legLength !== null && props.searchPattern.legLength.trim().length > 0) ||
				 props.searchPattern.numberOfLegs !== null ||
				 (props.searchPattern.trackSpacing !== null && props.searchPattern.trackSpacing.trim().length > 0))
	})

	return () => (
		<>
			<EditableField
				hasValue={!!hasSearchPatternDetails.value}
				edit={() => (editing.value = true)}
				showOnReadOnly={hasSearchPatternDetails.value}
			>
				<div class="flex items-center justify-center">
					{hasSearchPatternDetails.value ? (
						<div class={existingInstructionsStyles}>
							<span>!</span>
							<Icon icon={faWaveSquare} />
						</div>
					) : (
						"-"
					)}
				</div>
			</EditableField>

			{editing.value && (
				<EditSearchPattern
					searchPattern={props.searchPattern}
					cancel={() => (editing.value = false)}
					setSearchPattern={async (searchPattern) => {
						await props.setSearchPattern(searchPattern)
						editing.value = false
					}}
				/>
			)}
		</>
	)
}

export default defineComponent(SearchPatternCell, inferProps<Props>())
